import React, { memo } from "react";
import { Box, Grid, Tooltip, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { FilePreview } from "@components/Views/FilePreview";
import { File } from "@interfaces/File";
import { truncateText } from "@modules/Utils";

const useStyles = makeStyles((theme) => ({
    item: {
        textAlign: "center",
        cursor: "pointer",
        borderRadius: 10,
        border: "2px solid transparent",
        "&:hover": {
            backgroundColor: theme.palette.action.hover,
        },
    },
    selected: {
        borderColor: theme.palette.primary.main,
        backgroundColor: theme.palette.action.selected,
    },
    disabled: {
        cursor: "not-allowed",
        opacity: 0.4,
        "&:hover": {
            backgroundColor: "transparent",
        },
    },
    name: {
        wordBreak: "break-all",
        padding: theme.spacing(0, 1),
    },
}));

type Props = {
    item: File;
    selected: boolean;
    disabled?: boolean;
    disabledReason?: string;
    onClick(file: File): void;
};

const FilePickerFileGridItem = ({ item, selected, disabled, disabledReason, onClick }: Props) => {
    const classes = useStyles();

    const content = (
        <Grid
            item
            xs={4}
            md={3}
            className={clsx(classes.item, {
                [classes.selected]: selected,
                [classes.disabled]: disabled,
            })}
            onClick={() => !disabled && onClick(item)}
        >
            <Box height={80} my={2}>
                <FilePreview
                    file={item.path}
                    containerStyle={{
                        maxWidth: 80,
                        maxHeight: 80,
                        margin: "auto",
                    }}
                    imageStyle={{
                        top: "50%",
                        bottom: "50%",
                    }}
                />
            </Box>
            <Typography className={classes.name} variant="body2" noWrap>
                {truncateText(item.name, 24) || "Без имени"}
            </Typography>
        </Grid>
    );

    if (disabled && disabledReason) {
        return (
            <Tooltip title={disabledReason} arrow>
                {content}
            </Tooltip>
        );
    }

    return content;
};

export default memo(FilePickerFileGridItem);
